// Dependency-free so the dashboard's inline boot script can read them without pulling in zod.
export const CUSTOMER_PRODUCTS_DEFAULT_LIMIT = 10;
export const CUSTOMER_PRODUCTS_MAX_LIMIT = 100;
